import React from 'react';

import { containerClass, innerClass } from './style.css';
import ReportProfile, { ReportProfileProps } from '../report-profile/ReportProfile';
import ReportProfileError from '../report-profile/ReportProfileError';
import ReportProfileLoading from '../report-profile/ReportProfileLoading';
import { is } from 'immer/dist/internal';
export interface ReportHeaderProps extends ReportProfileProps {
	isLoading?: boolean;
	isError?: boolean;
}

const ReportHeader = ({ isLoading, isError, ...props }: ReportHeaderProps) => {
	console.log(props, 'props');
	return (
		<div className={containerClass}>
			<div className={innerClass}>
				{!isLoading && !isError && <ReportProfile {...props} />}
				{isLoading && (
					<ReportProfileLoading rawData={{ 게시물: '', 팔로워: '', 팔로잉: '' }} />
				)}{' '}
				{/*수정되어야 함*/}
				{isError && (
					<ReportProfileError rawData={{ 게시물: '', 팔로워: '', 팔로잉: '' }} />
				)}
			</div>
		</div>
	);
};

export default ReportHeader;
